import '@backstage/cli/asset-types';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Red Hat fonts (Display/Text/Mono) bundled with the RHDH theme package.
// The dist build doesn't carry the CSS import, so load it explicitly.
import '@redhat-developer/red-hat-developer-hub-theme/src/fonts/font.css';
import { trackUxSignal } from './components/ui';

// `cimode` renders raw i18n keys (for debugging), which makes labels look broken.
// Force a normal language in production UI.
const currentLanguage = window.localStorage
  .getItem('i18nextLng')
  ?.toLowerCase();
if (!currentLanguage || currentLanguage.includes('cimode')) {
  window.localStorage.setItem('i18nextLng', 'en');
}

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    const nav = performance.getEntriesByType('navigation')[0] as
      | PerformanceNavigationTiming
      | undefined;
    if (!nav) return;
    trackUxSignal('ui.page.load', {
      domInteractiveMs: Math.round(nav.domInteractive),
      domCompleteMs: Math.round(nav.domComplete),
      transferSize: nav.transferSize,
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
